import { render, staticRenderFns } from "./FlightCard.vue?vue&type=template&id=5f3c263d&scoped=true"
import script from "./FlightCard.vue?vue&type=script&lang=js"
export * from "./FlightCard.vue?vue&type=script&lang=js"
import style0 from "./FlightCard.vue?vue&type=style&index=0&id=5f3c263d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c263d",
  null
  
)

export default component.exports